$(document).on('submit', '#form-cert-order', function () {
	var route = $(this).attr('action');
	var params = $(this).serializeArray();
	var $modal = $(this).closest("#modal-cert-order");

	var $btn = $modal.find('button[type=submit]');
	var prevText = $btn.text();
	$btn.text('Оформляем заказ...').attr('disabled', 'disabled');

	var $msgError = $modal.find('.msg.msg-error');
	$msgError.hide();

	$.post(route, params, function (data) {
		if (data.error) {
			$btn.text(prevText).removeAttr('disabled');
			$msgError.text(data.msg).show();
		} else {
			yaCounterReachGoal('order');
			location.href = data.redirect_to;
		}
	});

	return false;
});

$(document).on('submit', '#form-cert-activate', function () {
	let route = $(this).attr('action');
	let params = $(this).serializeArray();
	let $msg = $(this).find('.msg');

	$msg.removeClass().slideUp();

	$.post(route, params, function (data) {
		if (data.error) {
			$msg.text(data.msg).addClass('msg text-danger').slideDown();
		} else {
			$("#modal-cert-order").remove();
			$('body').append(data.view);
			$("#modal-cert-order").modal('show')
		}
	});

	return false;
});

$(document).on('submit', '#form-cert-activate2', function () {

});